<div class="example-container no-scroll">
  <mat-toolbar class="example-toolbar" style="background-color: #f2f7fb; color: #004f91;">
    <span class="example-spacers"></span>
    <button *ngIf="!deviceXs" mat-icon-button (click)="sidenav.toggle()" style="left: 2.2rem; ">
      <mat-icon *ngIf="!sidenav.opened">menu</mat-icon>
      <mat-icon *ngIf="sidenav.opened">menu</mat-icon>
    </button>
    <button *ngIf="deviceXs" mat-icon-button (click)="sidenav.toggle()">
      <mat-icon *ngIf="!sidenav.opened">menu</mat-icon>
      <mat-icon *ngIf="sidenav.opened">menu</mat-icon>
    </button>
    <img *ngIf="deviceXs" src="assets/img/logo_cofide.png" width="138" style="margin-left: 20px; cursor: pointer; "
      routerLink="/home/inicio" alt="logo_cofide">

    <span class="example-spacer"></span>
    <span>{{AppTitle}}</span>

    <div class="usuario-content">
      <div class="" usuario-subcontent>
        <div class="user">{{username}}</div>
        <div class="rol">{{rol}}</div>
      </div>

      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="icon-display">account_circle</mat-icon>
      </button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="cerrarSession()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Volver a mis Productos</span>
      </button>
    </mat-menu>
  </mat-toolbar>

  <mat-sidenav-container class="example-sidenav-container disable-scrollbars">
    <mat-sidenav #sidenav style="width: 250px;" [opened]="!isScreenSmall" [mode]="isScreenSmall ?'over':'side'"
      class="disable-scrollbars">
      <a href="#/home/inicio">
        <img src="assets/img/logo_cofide.png" alt="Logo Cofide" width="80%" height="100">
      </a>
      <mat-accordion [multi]="true">
        <!-- <mat-expansion-panel *ngFor="let menu of lstMenu"> -->
        <mat-expansion-panel *ngFor="let menu of lstMenu" (opened)="onPanelOpen(menu)" (closed)="onPanelClose(menu)"
          [expanded]="menu === openedPanel">
          <mat-expansion-panel-header class="light-color">
            <mat-panel-title>
              <mat-icon *ngIf=" menu.icono && menu.icono.includes('--')" svgIcon="{{menu.icono}}"></mat-icon>
              <mat-icon *ngIf="menu.icono && !menu.icono.includes('--')">{{menu.icono}}</mat-icon>
              &nbsp; &nbsp;{{menu.nombre}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion [multi]="true">
            <div *ngFor="let subitem of lstSubMenu">
              <mat-expansion-panel *ngIf="subitem.tieneHijos == true" (opened)="onPanelOpenSubmenu(subitem)" (closed)="onPanelOpenSubmenu(subitem)">
                <mat-expansion-panel-header class="disable_ripple fsize-13" *ngIf=" subitem.idMenuPadre == menu.id">
                  <mat-panel-title>
                    <mat-icon>{{subitem.icono}}</mat-icon>&nbsp;
                    <button class="disable_ripple" mat-menu-item (click)="deviceXs ? sidenav.toggle() : myfunction() "
                      routerLink="{{subitem.url}}" style="cursor: pointer;">
                      <span style="color: #ffffff !important; ">{{subitem.nombre}}</span>
                    </button>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngFor="let subitem2 of lstSubMenu">
                  <button class="disable_ripple"
                    *ngIf="(subitem2.idMenuPadre == subitem.id && (subitem2.url != '' || subitem2.url != null))"
                    mat-menu-item (click)="myfunction()" routerLink="{{subitem2.url}}"
                    style="cursor: pointer;padding-left: 3.8rem;">
                    <span style="color: #ffffff !important; font-size: 12px;">{{subitem2.nombre}}</span>
                  </button>
                </div>
                <mat-divider></mat-divider>
              </mat-expansion-panel>
              <div *ngIf="subitem.tieneHijos == false">
                <button class="disable_ripple" *ngIf=" subitem.idMenuPadre == menu.id" mat-menu-item
                  (click)="myfunction()" routerLink="{{subitem.url}}" style="cursor: pointer;padding-left: 3.8rem;">
                  <span style="color: #ffffff !important; font-size: 12px;">{{subitem.nombre}}</span>
                </button>
              </div>
            </div>
          </mat-accordion>
          <mat-divider></mat-divider>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-sidenav>

    <div class="example-sidenav-content">
      <!-- <div class="row-buttons-retroalimentacion">
        <button mat-flat-button class="button-cancelar-outline">Queremos conocerte!</button>
      </div> -->

      <div class="chatbot-icon-container"
        [style.bottom.px]="positionY"
        [style.right.px]="positionX"
        (mousedown)="startDrag($event)"
        (mousemove)="drag($event)"
        (mouseup)="stopDrag($event)"
        (mouseleave)="stopDrag($event)"
        (click)="AbrirCalificador()"
        >
        <div class="chatbot-message-bubble">
          ¡Queremos conocerte!
        </div>
        <button class="chatbot-icon" (click)="AbrirCalificador()">
          <!-- <mat-icon>chat</mat-icon> -->
          <img src="assets/icons/chatbot.png" alt="*">
        </button>
      </div>
      <div>
         <router-outlet></router-outlet>
      </div>

    </div>
  </mat-sidenav-container>
</div>
